/**
 * Indexer API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
package indexer.codegen

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

/**
 *
 * @param createdAt
 * @param createdAtHeight
 * @param perpetualId
 * @param ticker
 * @param oraclePrice
 * @param size
 * @param side
 * @param rate
 * @param payment
 * @param subaccountNumber
 * @param fundingIndex
 */
@JsExport
@Serializable
data class IndexerFundingPaymentResponseObject(

    val createdAt: IndexerIsoString? = null,
    val createdAtHeight: kotlin.String? = null,
    val perpetualId: kotlin.String? = null,
    val ticker: kotlin.String? = null,
    val oraclePrice: kotlin.String? = null,
    val size: kotlin.String? = null,
    val side: kotlin.String? = null,
    val rate: kotlin.String? = null,
    val payment: kotlin.String? = null,
    val subaccountNumber: kotlin.String? = null,
    val fundingIndex: kotlin.String? = null
)
